<template>
  <div class="login-view">
    <b-notification ref="element" :closable="false" class="bg-white card">
      <div class="title-page text-center">{{ $t('C009_1') }}</div>
      <div>
        <b-message :active.sync="isActive" class="mb-20" type="is-danger">
          {{ message }}
        </b-message>
      </div>
      <div class="form-login">
        <div class="form-input-mg-bot">
          <div class="form-title">{{ $t('C009_2') }}</div>
          <b-field
            :message="($v.email.$error) ? $t('EF2004_Content') : ''"
            :type="($v.email.$error) ? 'is-danger' : ''"
            label=""
          >
            <b-input
              v-model="email"
              class="height_input"
              @blur="$v.email.$touch"
            />
          </b-field>
        </div>
        <div class="form-input-mg-bot">
          <div class="form-title">{{ $t('C009_4') }}</div>
          <b-field
            :message="($v.password.$error) ? $t('EF2006_Content') : ''"
            :type="($v.password.$error) ? 'is-danger' : ''"
            label=""
          >
            <b-input
              v-model="password"
              :placeholder="$t('C009_5')"
              type="password"
              class="height_input"
              maxlength="16"
              @blur="$v.password.$touch"
              @keyup.enter.native="login"
            />
          </b-field>
        </div>
        <button
          class="btn-event-login is-primary button"
          @click="login"
          @keyup.enter="login"
        >
          {{ $t('C009_1') }}
        </button>
<!--        <div class="text-forget-pass">-->
<!--          <a @click="$router.push({ name: 'ForgetPassword'})">{{ $t('C009_7') }}</a>-->
<!--        </div>-->
        <div>
          <br/>
          <br/>
        </div>
        <div class="c-bg-grey text-center">
          <div class="text-g-login ">{{ $t('C009_8') }}</div>
          <a class="btn-g-login button" @click="$router.push('register')">{{
            $t('C009_9')
          }}</a>
        </div>
      </div>
    </b-notification>
  </div>
</template>
<style lang="scss">
.height_input .input {
  height: 48px;
}
</style>
<style lang="scss" src="../register/register.scss" scoped>
</style>
<script>
import * as userService from '@/services/user.service';
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import { Component, Vue } from 'vue-property-decorator';
import { strictPassword } from '@/utils/validateUtil';

@Component({
  mixins: [validationMixin],
  validations: {
    email: { required, email },
    password: { required, strictPassword }
  }
})
export default class LoginForm extends Vue {
  email = '';
  password = '';
  isActive = false;
  message = '';

  created() {
    userService.checkRoleAndRenderView('/', this.$router);
  }

  mounted() {
    parent.scrollTo(0, 0);
  }

  openLoading() {
    let loadingComponent = this.$loading.open({
      container: null
    });
    return loadingComponent;
  }

  closeLoading(loadingComponent) {
    loadingComponent.close();
  }

  async login() {
    // trigger vuelidate validation
    this.$v.$touch();
    if (this.$v.$error) {
      return;
    }
    this.isActive = false;
    this.message = null;
    const loadingComponent = this.openLoading();
    let that = this;
    try {
      let res = await userService.signIn(this.email, this.password);
      if (res.status === 1) {
        // Redirect to page that user expects to see after login
        if (
          this.$route.params !== null &&
          this.$route.params.page_expectations !== null &&
          typeof this.$route.params.page_expectations !== 'undefined'
        ) {
          this.$router.push(this.$route.params.page_expectations);
        } else {
          this.$router.push('/');
        }
      } else {
        this.isActive = true;
        this.message = this.$t(res.result.messageId);
      }
    } catch (err) {
      //check email vs pass incorrect
      that.isActive = true;
      that.message = that.$t('EF2008_Content');
    } finally {
      this.closeLoading(loadingComponent);
    }
  }
}
</script>
